var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPushPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6663 8.58065C12.6663 8.26732 12.4397 8.01398 12.133 7.92732C11.2863 7.69398 10.6663 6.92065 10.6663 6.00065V2.66732H11.333C11.6997 2.66732 11.9997 2.36732 11.9997 2.00065C11.9997 1.63398 11.6997 1.33398 11.333 1.33398H4.66634C4.29967 1.33398 3.99967 1.63398 3.99967 2.00065C3.99967 2.36732 4.29967 2.66732 4.66634 2.66732H5.33301V6.00065C5.33301 6.92065 4.71301 7.69398 3.86634 7.92732C3.55967 8.01398 3.33301 8.26732 3.33301 8.58065V8.66732C3.33301 9.03398 3.63301 9.33398 3.99967 9.33398H7.31967L7.33301 14.0007C7.33301 14.3673 7.63301 14.6673 7.99967 14.6673C8.36634 14.6673 8.66634 14.3673 8.66634 14.0007L8.65301 9.33398H11.9997C12.3663 9.33398 12.6663 9.03398 12.6663 8.66732V8.58065Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPushPin);
export default __webpack_public_path__ + "static/media/PushPin.53b7dcbb054e6b94153ae8bbb1ba8bf1.svg";
export { ForwardRef as ReactComponent };